
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./nexo.cjs.production.min.js')
} else {
  module.exports = require('./nexo.cjs.development.js')
}
